export default __webpack_public_path__ + "static/media/aboutus.b312a1b1.jpeg";